﻿// Currently not in use but can be used if FAQBlock.cshtml is updated to include categories,
// then use same markup as in CategorizedFAQQuestionBlock.jsx

export default class FaqCategoryScrollHandler {
    constructor() {
        const categoryContainer = document.getElementById('faq__category-container');
        const scrollContainer = document.getElementById('faq__scroll-container');
        const scrollButtons = Array.from(document.getElementsByClassName('faq__scroll-button'));

        if ( scrollContainer && scrollButtons.length > 0) {

            this.toggleScrollable(categoryContainer, scrollContainer);

            scrollButtons.forEach(button => {
                button.addEventListener('click', function () {
                    const direction = button.id === 'faq__scroll-left' ? -100 : 100;
                    scrollContainer.scrollBy({
                        left: direction,
                        behavior: 'smooth'
                    });
                });
            });
        };
    }

    hasScroll(scrollContainer) {
            return scrollContainer.scrollWidth > scrollContainer.clientWidth
    }

    toggleScrollable(categoryContainer, scrollContainer) {
        if (this.hasScroll(scrollContainer)) {
            categoryContainer.classList.add('visible');
        } else {
            categoryContainer.classList.remove('visible');
        }
    }
}